import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { IStudiesAllStateParamsUnboxed } from '../state/ui/study-table-ui.model';
import {
  MyStudiesTab,
  PagedDataDtoOfStudyDetailsDto,
} from '@core/services/api-client.generated';

export type StudiesTableScope = 'project' | 'stage';

/** Why the server refused slice 9's Proposed PDF waiting filter. */
export type ProposedPdfFilterRefusal = 'unavailable' | 'tooMany' | 'forbidden';

export const studiesActions = createActionGroup({
  source: 'Studies',
  events: {
    // `myStudiesTab`: the Studies workspace's My studies tab (#4720), from its URL; absent (None) everywhere else.
    'fetch study list': props<
      IStudiesAllStateParamsUnboxed & { myStudiesTab?: MyStudiesTab }
    >(),
    // Fetch the list again with the parameters already in the store (reversible deletion S4a: a search was deleted).
    'refresh study list': emptyProps(),
    'navigate table': props<{ fromRow: number; pageSize: number }>(),
    'study list updated': props<PagedDataDtoOfStudyDetailsDto>(),
    // The fetch failed: the Library shows its in-page error state, and "Try again" dispatches refreshStudyList.
    'study list load failed': emptyProps(),
    // The Library filter bar's "Clear filters"; the filtered-empty state also clears the search term.
    'clear filters': props<{ includeSearchTerm: boolean }>(),
    // #4719: the server refused the Studies workspace's PDF filter (409 pdf-status-filter-unavailable). The filter goes
    // back to Any and is hidden until the next page load; the URL rewrite that follows fetches the list once more.
    'pdf status filter refused': emptyProps(),
    // Slice 9: the server refused Proposed PDF waiting: 409 study-pdf-proposals-unavailable (the index is missing),
    // 409 study-pdf-proposals-too-many, or 403 (the reader can't Set). The filter goes back to Any; the option stays
    // hidden until the next page load, and the URL rewrite that follows fetches the list once more.
    'proposed pdf filter refused': props<{ reason: ProposedPdfFilterRefusal }>(),
    // #4719: a W2 set, clear or accept succeeded, so a study's PDF link changed. The Searches pane's PDF counts are
    // fetched again on it (a reject or a proposal changes no link, so neither sends it).
    'study pdf link changed': emptyProps(),
  },
});
